import React from "react";
import { ImageGalleryProps } from "../../types/interface";
import trending from "../../assets/icons/trending.svg";
import Inference from "./Inference";
import { useTest } from "./TestContext";
import Blank from "./Blank";
import InferenceOther from "./InferenceOther";
import BlankOther from "./BlankOther";
import LoaderGIF from "../../assets/img/loader.gif";
import {
  Box,
  Card,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
const Testing: React.FC<ImageGalleryProps> = ({ id }) => {
  const {
    filename,
    fileUpload,
    handleFileChange,
    fileInputRef,
    compare,
    loadInference,
    loadOtherInference,
  } = useTest();

  const getFileExtension = (fileName: string) => {
    return fileName.split(".").pop()?.toLowerCase() || "";
  };

  return (
    <Box sx={{ margin: "20px" }}>
      <Grid container spacing={2}>
        <Grid
          item
          md={compare ? 3 : 4}
          sx={{ justifyContent: "space-between" }}
        >
          <div style={{ background: "#fff", height: "100%" }}>
            <Card sx={{ padding: "10px", boxShadow: "none" }}>
              <h3 style={{ color: "#939393", fontWeight: "400" }}>
                Uploaded Test Image
              </h3>
              <div
                id="testUploadImage"
                className="container"
                style={{
                  position: "relative",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <input
                  type="file"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />
                <img
                  src={fileUpload ? URL.createObjectURL(fileUpload) : ""}
                  alt="Drag or Click to upload"
                  style={{
                    // maxWidth: "250px",
                    // maxHeight: "350px",
                    width: "100%",
                    maxHeight: "320px",
                    marginRight: "5px",
                    cursor: "pointer",
                    objectFit: "contain",
                  }}
                  className="image changeImg"
                  onClick={() => {
                    if (fileInputRef.current) {
                      fileInputRef.current.click(); // Trigger file input on click
                    }
                  }}
                />
                <div className="button-container">
                  <button
                    className="change-btn"
                    onClick={() => {
                      if (fileInputRef.current) {
                        fileInputRef.current.click(); // Trigger file input on click
                      }
                    }}
                  >
                    {/* <PublishIcon style={{ fontSize: "20px" }} /> */}
                    <img src={trending} alt="Change" />
                    Change Image
                  </button>
                </div>
              </div>

              <br />
              <TableContainer sx={{ overflow: "visible" }}>
                <Table aria-label="simple table">
                  <TableBody>
                    <TableRow sx={{ border: 0, padding: "10px" }}>
                      <TableCell
                        component="td"
                        sx={{
                          border: 0,
                          color: "#666",
                          // width: "25%",
                          padding: "10px",
                          fontWeight: "600",
                          width: "50px",
                        }}
                      >
                        File Name:
                      </TableCell>
                      <TableCell
                        component="td"
                        sx={{
                          border: 0,
                          padding: "10px",
                          fontWeight: "600",
                          maxWidth: "130px",
                        }}
                      >
                        <abbr
                          title={filename.name}
                          style={{
                            textDecoration: "none",
                            width: compare ? "220px" : "340px",
                            overflow: "hidden",
                            display: "inline-block",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {filename.name}
                        </abbr>
                      </TableCell>
                    </TableRow>
                    <TableRow sx={{ border: 0 }}>
                      <TableCell
                        component="td"
                        scope="row"
                        sx={{
                          border: 0,
                          color: "#666",
                          // width: "25%",
                          padding: "10px",
                          fontWeight: "600",
                        }}
                      >
                        Format:
                      </TableCell>
                      <TableCell
                        component="td"
                        sx={{
                          border: 0,
                          padding: "10px",
                          fontWeight: "600",
                          maxWidth: "130px",
                        }}
                      >
                        <p
                          style={{
                            maxWidth: "200px",
                            overflow: "hideen",
                            textOverflow: "ellipsis",
                            fontSize: "14px",
                            margin: "0",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <abbr
                            title={getFileExtension(filename?.name)}
                            style={{ textDecoration: "none" }}
                          >
                            {getFileExtension(filename?.name)}
                          </abbr>
                        </p>
                      </TableCell>
                    </TableRow>

                    <TableRow sx={{ border: 0, padding: "10px" }}>
                      <TableCell
                        component="td"
                        sx={{
                          border: 0,
                          color: "#666",
                          // width: "25%",
                          padding: "10px",
                          fontWeight: "600",
                        }}
                      >
                        Size:
                      </TableCell>
                      <TableCell
                        component="td"
                        sx={{
                          border: 0,
                          padding: "10px",
                          fontWeight: "600",
                          maxWidth: "130px",
                        }}
                      >
                        <p
                          style={{
                            maxWidth: "200px",
                            overflow: "hideen",
                            textOverflow: "ellipsis",
                            fontSize: "14px",
                            margin: "0",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <abbr
                            title={filename?.size}
                            style={{ textDecoration: "none" }}
                          >
                            {filename?.size}
                          </abbr>
                        </p>
                      </TableCell>
                    </TableRow>
                    <TableRow sx={{ border: 0, padding: "10px" }}>
                      <TableCell
                        component="td"
                        sx={{
                          border: 0,
                          color: "#666",
                          // width: "25%",
                          padding: "10px",
                          fontWeight: "600",
                        }}
                      >
                        Dimension
                      </TableCell>
                      <TableCell
                        component="td"
                        sx={{
                          border: 0,
                          padding: "10px",
                          fontWeight: "600",
                          maxWidth: "130px",
                        }}
                      >
                        <p
                          style={{
                            maxWidth: "200px",
                            overflow: "hideen",
                            textOverflow: "ellipsis",
                            fontSize: "14px",
                            margin: "0",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <abbr
                            title={filename?.dimensions}
                            style={{ textDecoration: "none" }}
                          >
                            {filename?.dimensions}
                          </abbr>
                        </p>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>
          </div>
        </Grid>

        <Grid
          item
          md={compare ? 4.5 : 8}
          xs={12}
          sx={{ justifyContent: "space-between", position: "relative" }}
        >
          {/* Overlay with text */}
          {loadInference && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)", // 20% transparent black
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                zIndex: 100, // Ensure the overlay is above other content
              }}
            >
              <div style={{ color: "#FFF", fontSize: "24px" }}>
                <img
                  src={LoaderGIF}
                  style={{
                    width: "100px",
                  }}
                  alt="another"
                />
                <p>Testing model</p>
              </div>
            </div>
          )}

          <Card sx={{ padding: "10px" }} variant="outlined">
            <Inference id={id} />
          </Card>
          <Card sx={{ padding: "10px", marginTop: "10px" }} variant="outlined">
            <Blank id={id} />
          </Card>
        </Grid>
        {compare ? (
          <>
            <Grid
              item
              md={compare ? 4.5 : 8}
              xs={12}
              sx={{ justifyContent: "space-between", position: "relative" }}
            >
              {/* Overlay with text */}
              {loadOtherInference && (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.5)", // 20% transparent black
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    zIndex: 100, // Ensure the overlay is above other content
                  }}
                >
                  <div style={{ color: "#FFF", fontSize: "24px" }}>
                    <img
                      src={LoaderGIF}
                      style={{
                        width: "100px",
                      }}
                      alt="alternate"
                    />
                    <p>Testing model</p>
                  </div>
                </div>
              )}
              <Card sx={{ padding: "10px" }} variant="outlined">
                <InferenceOther id={id} />
              </Card>
              <Card
                sx={{ padding: "10px", marginTop: "10px" }}
                variant="outlined"
              >
                <BlankOther id={id} />
              </Card>
            </Grid>
          </>
        ) : (
          ""
        )}
      </Grid>
    </Box>
  );
};

export default Testing;
